import type { PropertySelectionRow } from "../../../types";

/**
 * 指定された地番の行を特定する関数（pinTypeに関係なく検索）
 */
export const findMapClickProperty = (
  properties: PropertySelectionRow[],
  location: string,
  chiban: string,
  prefName: string
): PropertySelectionRow | undefined => {
  return properties.find(
    (row) =>
      row.location === location &&
      row.chibanKaokuNumber === chiban &&
      row.prefName === prefName
  );
};

/**
 * ポップアップ識別子を使って行を特定する関数
 */
export const findPropertyByIdentifier = (
  properties: PropertySelectionRow[],
  identifier: { location: string; chiban: string }
): PropertySelectionRow | undefined => {
  return properties.find(
    (row) =>
      row.location === identifier.location &&
      row.chibanKaokuNumber === identifier.chiban
  );
};
